"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var axios_1 = __importDefault(require("axios"));
var stripe_js_1 = require("@stripe/stripe-js");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var CheckoutForm_1 = __importDefault(require("../Donations/CheckoutForm"));
var SavedPaymentMethods_1 = __importDefault(require("../Donations/SavedPaymentMethods"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
var TWI_GIFT_PRICE_PER_MONTH = 9.99;
var TWI_GIFT_DURATION_OPTIONS = [
    { months: 1, label: '1 Month' },
    { months: 3, label: '3 Months' },
    { months: 6, label: '6 Months' },
    { months: 9, label: '9 Months' },
    { months: 12, label: '1 Year (max)' },
];
function getTwiGiftPrice(months) {
    return Math.round(TWI_GIFT_PRICE_PER_MONTH * months * 100) / 100;
}
var EMPTY_SHIPPING = {
    first_name: '',
    last_name: '',
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    postcode: '',
    country: '',
};
// Shipping + tax constants for physical Discourse (Book) orders.
// Flat estimates — can swap to a zip-based lookup later if needed.
var SHIPPING_FEE_US = 15;
var SHIPPING_FEE_INTL = 35;
var CA_TAX_RATE = 0.0975; // 9.75% — Los Angeles city combined rate.
var US_COUNTRY_TOKENS = ['us', 'usa', 'united states', 'united states of america'];
function isUsCountry(country) {
    return US_COUNTRY_TOKENS.includes(country.trim().toLowerCase());
}
function getShippingFee(country) {
    return isUsCountry(country) ? SHIPPING_FEE_US : SHIPPING_FEE_INTL;
}
function getCaTax(merchandise, shipping, state, country) {
    if (!isUsCountry(country))
        return 0;
    if (state.trim().toUpperCase() !== 'CA')
        return 0;
    return Math.round((merchandise + shipping) * CA_TAX_RATE * 100) / 100;
}
// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
function getDiscoursePrice(year, rate, format) {
    if (rate === void 0) { rate = 'individual'; }
    if (format === void 0) { format = 'digital'; }
    if (year === 'all')
        return 200;
    if (rate === 'replacement')
        return 50;
    if (rate === 'family')
        return 50;
    return Number(year) === 1 ? 50 : 100;
}
function getYearLabel(year, rate, format) {
    if (rate === void 0) { rate = 'individual'; }
    if (format === void 0) { format = 'digital'; }
    if (year === 'all')
        return (0, Lang_js_1.__)('All 12 Years (Digital)') + ' — $200';
    var price = getDiscoursePrice(year, rate, format);
    return (0, Lang_js_1.__)('Year') + ' ' + year + ' — $' + price;
}
/**
 * Year options depend on the selected rate:
 *   - individual / family : only the NEXT year after curryear (or Year 1 if not subscribed)
 *   - replacement         : any prior year 1..curryear (empty if not subscribed)
 *
 * Year 12 completers are routed away from this flow by the portal (no RENEW NOW
 * button); the 12-year bundle is treated as a store item handled elsewhere.
 */
function buildYearOptions(currentYear, rate, format) {
    var options = [];
    if (currentYear >= 12)
        return options;
    var nextYear = currentYear > 0 ? currentYear + 1 : 1;
    if (rate === 'replacement') {
        for (var y = 1; y <= currentYear; y++) {
            options.push({ value: String(y), label: getYearLabel(y, rate, format) });
        }
        return options;
    }
    // individual / family — only the next year
    if (nextYear <= 12) {
        options.push({ value: String(nextYear), label: getYearLabel(nextYear, rate, format) });
    }
    return options;
}
function getProductParam() {
    var params = new URLSearchParams(window.location.search);
    var p = params.get('product');
    if (p === 'discourse' || p === 'sat' || p === 'twi-gift')
        return p;
    return null;
}
// Discourse edition-language carried from the manage listing (the language the
// member chose to read). French and Bulgarian Discourses are Digital (PDF) only
// — there are no printed booklets — so Book is unavailable for those editions.
var DIGITAL_ONLY_EDITIONS = ['fr', 'bg'];
function getEditionParam() {
    return new URLSearchParams(window.location.search).get('edition') || '';
}
var SelectionCard = function (_a) {
    var label = _a.label, selected = _a.selected, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick;
    return (react_1.default.createElement(Paper_1.default, { onClick: disabled ? undefined : onClick, elevation: 0, sx: {
            border: '2px solid',
            borderColor: selected ? '#1c1c3c' : '#e0e0e0',
            borderRadius: '6px',
            px: '18px',
            py: '10px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            backgroundColor: selected
                ? 'rgba(28,28,60,0.04)'
                : disabled
                    ? '#fafafa'
                    : '#fff',
            color: disabled ? '#bbb' : '#1c1c3c',
            fontSize: '14px',
            fontWeight: selected ? 700 : 500,
            userSelect: 'none',
            transition: 'border-color 0.15s ease, background-color 0.15s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            minWidth: '120px',
            justifyContent: 'center',
            '&:hover': !disabled
                ? {
                    borderColor: selected ? '#1c1c3c' : '#aaa',
                }
                : {},
        } },
        react_1.default.createElement(Box_1.default, { component: "span", sx: {
                width: '14px',
                height: '14px',
                borderRadius: '50%',
                border: '2px solid',
                borderColor: selected ? '#1c1c3c' : '#ccc',
                backgroundColor: selected ? '#1c1c3c' : 'transparent',
                flexShrink: 0,
                transition: 'background-color 0.15s ease',
                display: 'inline-block',
            } }),
        label));
};
// ---------------------------------------------------------------------------
// SectionLabel — small uppercase heading inside config card
// ---------------------------------------------------------------------------
var SectionLabel = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(Typography_1.default, { sx: {
            fontSize: '11px',
            fontWeight: 700,
            color: '#888',
            textTransform: 'uppercase',
            letterSpacing: '0.6px',
            mb: '6px',
            lineHeight: 1,
        } }, children));
};
var StatusPill = function (_a) {
    var label = _a.label, active = _a.active;
    return (react_1.default.createElement(Box_1.default, { sx: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            backgroundColor: active ? 'rgba(25, 148, 32, 0.08)' : 'rgba(211, 47, 47, 0.08)',
            px: '12px',
            py: '6px',
            borderRadius: '20px',
        } },
        react_1.default.createElement(Box_1.default, { component: "span", sx: {
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: active ? '#199420' : '#d32f2f',
                display: 'inline-block',
                flexShrink: 0,
            } }),
        react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, label)));
};
var YearOption = function (_a) {
    var label = _a.label, selected = _a.selected, onClick = _a.onClick;
    return (react_1.default.createElement(Box_1.default, { onClick: onClick, sx: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            px: '14px',
            py: '10px',
            border: '2px solid',
            borderColor: selected ? '#1c1c3c' : '#e0e0e0',
            borderRadius: '6px',
            cursor: 'pointer',
            backgroundColor: selected ? 'rgba(28,28,60,0.04)' : '#fff',
            transition: 'border-color 0.15s ease, background-color 0.15s ease',
            fontSize: '14px',
            fontWeight: selected ? 700 : 400,
            color: '#1c1c3c',
            userSelect: 'none',
            '&:hover': {
                borderColor: selected ? '#1c1c3c' : '#aaa',
            },
        } },
        react_1.default.createElement(Box_1.default, { component: "span", sx: {
                width: '14px',
                height: '14px',
                borderRadius: '50%',
                border: '2px solid',
                borderColor: selected ? '#1c1c3c' : '#ccc',
                backgroundColor: selected ? '#1c1c3c' : 'transparent',
                flexShrink: 0,
                transition: 'background-color 0.15s ease',
                display: 'inline-block',
            } }),
        label));
};
var RateOptionDescriptions = function (_a) {
    var product = _a.product, rate = _a.rate;
    var text = '';
    if (rate === 'individual') {
        text = product === 'discourse'
            ? (0, Lang_js_1.__)('Standard yearly Discourse subscription for one person.')
            : (0, Lang_js_1.__)('Standard yearly SAT subscription for one person.');
    }
    else if (rate === 'family') {
        // Same explanation for Discourse and SAT — only shown to family-eligible
        // accounts renewing their primary subscription.
        text = (0, Lang_js_1.__)("An existing subscriber's spouse or child between ages 16-21 living at home can receive a special family rate of $50 when renewing their primary subscription. (For example: In a three-person family, the first member pays $100. Their spouse pays $50. And the child of that couple pays $50.)");
    }
    else if (rate === 'replacement') {
        text = (0, Lang_js_1.__)('If you are already a subscriber to Soul Awareness Discourses and you want to buy a replacement set of Discourses for a year you have previously purchased, please select the appropriate year.');
    }
    if (!text)
        return null;
    return (react_1.default.createElement(Typography_1.default, { sx: {
            mt: '10px',
            fontSize: '12px',
            color: '#666',
            fontStyle: 'italic',
            lineHeight: 1.5,
        } }, text));
};
// ---------------------------------------------------------------------------
// Main Component
// ---------------------------------------------------------------------------
var SubscriptionCart = function () {
    var container = document.getElementById('subscription-cart');
    var dataset = (container === null || container === void 0 ? void 0 : container.dataset) || {};
    var lang = dataset.lang || 'en';
    var memberId = dataset.memberId || '';
    var isInitiate = dataset.isInitiate === '1';
    var isMinister = dataset.isMinister === '1';
    var isDiscourse = dataset.isDiscourse === '1';
    var isSat = dataset.isSat === '1';
    var cartContext = {
        discourse_current_year: 0,
        discourse_status: null,
        sat_status: null,
    };
    try {
        if (dataset.cartContext) {
            cartContext = JSON.parse(dataset.cartContext);
        }
    }
    catch (e) {
        console.warn('Failed to parse cart-context', e);
    }
    var product = getProductParam();
    var discourseCurrentYear = cartContext.discourse_current_year || 0;
    var discourseCompleted = discourseCurrentYear >= 12;
    // State
    var _a = (0, react_1.useState)('digital'), format = _a[0], setFormat = _a[1];
    var _b = (0, react_1.useState)('individual'), rate = _b[0], setRate = _b[1];
    var _c = (0, react_1.useState)(cartContext.shipping_default || EMPTY_SHIPPING), shipping = _c[0], setShipping = _c[1];
    // TWI Gift state — only used when product=twi-gift
    var _d = (0, react_1.useState)(1), giftMonths = _d[0], setGiftMonths = _d[1];
    var _e = (0, react_1.useState)('myself'), giftRecipient = _e[0], setGiftRecipient = _e[1];
    var _f = (0, react_1.useState)(''), giftNotes = _f[0], setGiftNotes = _f[1];
    // Family rate is gated on the GP-synced subscription_class_id AND on this
    // product being the member's PRIMARY subscription — the family rate is only
    // offered when renewing a primary. The backend resolves both into per-product
    // flags (discourse_family_eligible / sat_family_eligible) so a member whose
    // family class applies to their Discourse (primary) does not also see it on an
    // expired secondary SAT. TWI gifts never offer a family rate.
    var showFamily = product === 'discourse'
        ? cartContext.discourse_family_eligible === true
        : product === 'sat'
            ? cartContext.sat_family_eligible === true
            : false;
    // Subscription language the member is renewing. Defaults to any ?edition= carried from
    // the manage listing, else the page language. The in-cart Language picker changes it,
    // which switches the cart copy in place (via setLang below) and is recorded on the order
    // so the processor knows which language edition to fulfill.
    var _g = (0, react_1.useState)(getEditionParam() || lang || 'en'), cartLang = _g[0], setCartLang = _g[1];
    // Point __() at the picked language for this render pass, so all copy below translates in
    // place. Idempotent module write; the cart is the only screen that switches locale.
    (0, Lang_js_1.setLang)(cartLang);
    var changeLang = function (l) { return setCartLang(l); };
    // Language options per product: SAT ships EN/ES/PT; Discourse adds FR/BG (the PDF-only
    // editions). Each has a translation file, so the cart copy switches in place.
    var languageOptions = product === 'sat'
        ? [{ code: 'en', name: 'English' }, { code: 'es', name: 'Español' }, { code: 'pt', name: 'Português' }]
        : [{ code: 'en', name: 'English' }, { code: 'es', name: 'Español' }, { code: 'fr', name: 'Français' }, { code: 'pt', name: 'Português' }, { code: 'bg', name: 'Български' }];
    // French and Bulgarian editions are Digital (PDF) only — Book is hidden and forced off.
    var editionLang = cartLang;
    var isDigitalOnlyEdition = product === 'discourse' && DIGITAL_ONLY_EDITIONS.includes(editionLang);
    // Year options depend on rate + format + curryear; rebuilt every render so the
    // label prices stay correct when the user flips between physical/digital on
    // Replacement or switches rates.
    var yearOptions = buildYearOptions(discourseCurrentYear, rate, format);
    var defaultYear = yearOptions.length > 0 ? yearOptions[0].value : '';
    var _h = (0, react_1.useState)(defaultYear), year = _h[0], setYear = _h[1];
    // Payment state
    var _j = (0, react_1.useState)(false), showPayment = _j[0], setShowPayment = _j[1];
    var _k = (0, react_1.useState)(null), clientSecret = _k[0], setClientSecret = _k[1];
    var _l = (0, react_1.useState)(null), customerId = _l[0], setCustomerId = _l[1];
    var _m = (0, react_1.useState)([]), savedMethods = _m[0], setSavedMethods = _m[1];
    var _o = (0, react_1.useState)(false), paymentLoading = _o[0], setPaymentLoading = _o[1];
    var _p = (0, react_1.useState)(null), paymentError = _p[0], setPaymentError = _p[1];
    // Stripe init
    var donationForm = document.getElementById('donation-form');
    var stripePromise = (0, stripe_js_1.loadStripe)((donationForm === null || donationForm === void 0 ? void 0 : donationForm.getAttribute('pk')) || '');
    // When year changes to 'all', force digital format
    (0, react_1.useEffect)(function () {
        if (year === 'all') {
            setFormat('digital');
        }
    }, [year]);
    // Replacement rate is book-only ($50 physical). Digital replacement is
    // retired per Leo's 6/26 update.
    (0, react_1.useEffect)(function () {
        if (rate === 'replacement') {
            setFormat('book');
        }
    }, [rate]);
    // French/Bulgarian Discourse editions are Digital (PDF) only — force digital.
    (0, react_1.useEffect)(function () {
        if (isDigitalOnlyEdition) {
            setFormat('digital');
        }
    }, [isDigitalOnlyEdition]);
    // Family is hidden for accounts the GP field marks non-family; if the rate is
    // somehow still 'family' (stale page, tampered state) snap back to individual.
    (0, react_1.useEffect)(function () {
        if (!showFamily && rate === 'family') {
            setRate('individual');
        }
    }, [showFamily, rate]);
    // If the current year is no longer valid for the selected rate, snap to
    // the first available option (or empty string if none exist).
    (0, react_1.useEffect)(function () {
        var valid = yearOptions.some(function (opt) { return opt.value === year; });
        if (!valid) {
            setYear(defaultYear);
        }
    }, [rate, discourseCurrentYear]);
    // ---------------------------------------------------------------------------
    // Payment handler
    // ---------------------------------------------------------------------------
    var handlePayNow = function () { return __awaiter(void 0, void 0, void 0, function () {
        var comment2, yearLabel, formatLabel, rateLabel, months, monthsLabel, recipientLabel, editionNames, transactionType, params, _i, _a, staleKey, intentRes, pmRes, _b, err_1;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setPaymentLoading(true);
                    setPaymentError(null);
                    comment2 = '';
                    if (product === 'discourse') {
                        yearLabel = year === 'all' ? 'All 12 Years' : "Year ".concat(year);
                        formatLabel = format === 'book' ? 'Book' : 'Digital';
                        rateLabel = rate === 'individual' ? 'Individual' : rate === 'family' ? 'Family' : 'Replacement';
                        comment2 = "".concat(yearLabel, " / ").concat(formatLabel, " / ").concat(rateLabel);
                    }
                    else if (product === 'twi-gift') {
                        months = giftMonths;
                        monthsLabel = months === 12 ? '1 Year' : "".concat(months, " Month").concat(months === 1 ? '' : 's');
                        recipientLabel = giftRecipient === 'myself' ? 'For Myself' : 'For Someone Else';
                        // Detail only — the product label ("TWI Gift") is added downstream
                        // when composing the receipt/thank-you description and is the
                        // admin's own Product column, so including it here would double it.
                        comment2 = "".concat(monthsLabel, " / ").concat(recipientLabel);
                    }
                    else {
                        comment2 = 'Annual';
                    }
                    editionNames = { es: 'Español', pt: 'Português', fr: 'Français', bg: 'Български' };
                    if ((product === 'discourse' || product === 'sat') && editionNames[editionLang]) {
                        comment2 = "".concat(comment2, " / ").concat(editionNames[editionLang]);
                    }
                    transactionType = product === 'discourse'
                        ? 'Discourse'
                        : product === 'twi-gift'
                            ? 'TWI Gift'
                            : 'SAT';
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 9, 10, 11]);
                    params = new URLSearchParams({
                        amount: String(Math.round(orderPrice * 100)),
                        type: transactionType,
                        comment1: product || '',
                        comment2: comment2,
                        origin: 'subscription-cart',
                    });
                    // Structured pricing inputs so the server can recompute the authoritative
                    // price (the amount above is advisory only — DonationsController binds it
                    // server-side via SubscriptionPriceService).
                    if (product === 'discourse') {
                        params.set('disc_year', String(year));
                        params.set('disc_rate', rate);
                        params.set('disc_format', format);
                        params.set('disc_edition', editionLang);
                    }
                    else if (product === 'sat') {
                        params.set('sat_rate', rate === 'family' ? 'family' : 'individual');
                    }
                    else if (product === 'twi-gift') {
                        params.set('gift_months', String(giftMonths));
                    }
                    // TWI Gift — surface the recipient details note as comment3 so it
                    // lands in Stripe metadata and the receipt body for Customer
                    // Service to act on. Trim and cap so we stay under Stripe's
                    // 500-char metadata limit per key.
                    if (product === 'twi-gift' && giftNotes.trim() !== '') {
                        params.set('comment3', giftNotes.trim().slice(0, 500));
                    }
                    // For physical Discourse orders, attach the shipping address so
                    // fulfillment can ship to whatever the user actually entered
                    // instead of defaulting to whatever GP last synced. Also pass the
                    // shipping fee and CA tax as separate metadata so the breakdown is
                    // visible alongside the combined order total.
                    if (product === 'discourse' && format === 'book') {
                        params.set('ship_first_name', shipping.first_name);
                        params.set('ship_last_name', shipping.last_name);
                        params.set('ship_address_1', shipping.address_1);
                        params.set('ship_address_2', shipping.address_2);
                        params.set('ship_city', shipping.city);
                        params.set('ship_state', shipping.state);
                        params.set('ship_postcode', shipping.postcode);
                        params.set('ship_country', shipping.country);
                        params.set('ship_fee', shippingFee.toFixed(2));
                        params.set('ship_tax', caTax.toFixed(2));
                    }
                    // Mirror the full intent param set onto the hidden donation form:
                    // SavedPaymentMethods rebuilds its own intent URL from these
                    // attributes (IntentURL.tsx), so anything missing here is silently
                    // dropped from saved-card orders — including the structured pricing
                    // fields the server requires to verify the amount. Optional keys are
                    // cleared first so a changed selection can't leave stale values.
                    if (donationForm) {
                        for (_i = 0, _a = [
                            'comment3', 'disc_year', 'disc_rate', 'disc_format', 'disc_edition', 'sat_rate', 'gift_months',
                            'ship_first_name', 'ship_last_name', 'ship_address_1', 'ship_address_2',
                            'ship_city', 'ship_state', 'ship_postcode', 'ship_country', 'ship_fee', 'ship_tax',
                        ]; _i < _a.length; _i++) {
                            staleKey = _a[_i];
                            donationForm.removeAttribute(staleKey);
                        }
                        params.forEach(function (value, key) { return donationForm.setAttribute(key, value); });
                    }
                    return [4 /*yield*/, axios_1.default.get("/api/donations/loginIntent?".concat(params.toString()))];
                case 2:
                    intentRes = _e.sent();
                    if (!(intentRes.data.status === 'success')) return [3 /*break*/, 7];
                    setClientSecret(intentRes.data.client_secret);
                    setCustomerId(intentRes.data.customer_id);
                    setShowPayment(true);
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, axios_1.default.get('/api/donations/getSavedPaymentMethods')];
                case 4:
                    pmRes = _e.sent();
                    if (pmRes.data.status === 'success' && pmRes.data.payment_methods) {
                        setSavedMethods(pmRes.data.payment_methods);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    _b = _e.sent();
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 8];
                case 7:
                    setPaymentError(intentRes.data.message || (0, Lang_js_1.__)('Unable to initialize payment.'));
                    _e.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    err_1 = _e.sent();
                    setPaymentError(((_d = (_c = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || (0, Lang_js_1.__)('Unable to initialize payment. Please try again.'));
                    return [3 /*break*/, 11];
                case 10:
                    setPaymentLoading(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    // ---------------------------------------------------------------------------
    // Derived values
    // ---------------------------------------------------------------------------
    var isRenewal = product === 'discourse' ? isDiscourse : product === 'sat' ? isSat : false;
    var pageTitle = '';
    if (product === 'discourse') {
        pageTitle = isRenewal ? (0, Lang_js_1.__)('Renew Discourses') : (0, Lang_js_1.__)('Subscribe to Discourses');
    }
    else if (product === 'sat') {
        pageTitle = isRenewal ? (0, Lang_js_1.__)('Renew SATs') : (0, Lang_js_1.__)('Subscribe to SATs');
    }
    else if (product === 'twi-gift') {
        pageTitle = (0, Lang_js_1.__)('TWI Gift Subscription');
    }
    else {
        pageTitle = (0, Lang_js_1.__)('Subscription Cart');
    }
    // Order summary values
    var discoursePrice = product === 'discourse' ? getDiscoursePrice(year, rate, format) : 0;
    var satPrice = product === 'sat' ? (rate === 'family' ? 50 : 100) : 0;
    var twiGiftPrice = product === 'twi-gift' ? getTwiGiftPrice(giftMonths) : 0;
    var merchandisePrice = product === 'discourse'
        ? discoursePrice
        : product === 'twi-gift'
            ? twiGiftPrice
            : satPrice;
    // Shipping and CA tax apply only to physical (Book) Discourse orders.
    var needsPhysicalShipping = product === 'discourse' && format === 'book';
    var shippingFee = needsPhysicalShipping ? getShippingFee(shipping.country) : 0;
    var caTax = needsPhysicalShipping
        ? getCaTax(merchandisePrice, shippingFee, shipping.state, shipping.country)
        : 0;
    var orderPrice = merchandisePrice + shippingFee + caTax;
    var orderItemLabel = '';
    if (product === 'discourse' && year) {
        var yearLabel = year === 'all'
            ? (0, Lang_js_1.__)('All 12 Years (Digital)')
            : "".concat((0, Lang_js_1.__)('Year'), " ").concat(year);
        var formatLabel = format === 'book' ? (0, Lang_js_1.__)('Book') : (0, Lang_js_1.__)('Digital');
        var rateLabel = rate === 'individual'
            ? (0, Lang_js_1.__)('Individual')
            : rate === 'family'
                ? (0, Lang_js_1.__)('Family')
                : (0, Lang_js_1.__)('Replacement');
        orderItemLabel = "".concat((0, Lang_js_1.__)('Discourses'), " \u2014 ").concat(yearLabel, " / ").concat(formatLabel, " / ").concat(rateLabel);
    }
    else if (product === 'sat') {
        var satRateLabel = rate === 'family' ? (0, Lang_js_1.__)('Family') : (0, Lang_js_1.__)('Individual');
        orderItemLabel = "".concat((0, Lang_js_1.__)('SAT Yearly Subscription'), " \u2014 ").concat(satRateLabel);
    }
    else if (product === 'twi-gift') {
        var monthsLabel = giftMonths === 12
            ? (0, Lang_js_1.__)('1 Year')
            : "".concat(giftMonths, " ").concat(giftMonths === 1 ? (0, Lang_js_1.__)('Month') : (0, Lang_js_1.__)('Months'));
        var recipientLabel = giftRecipient === 'myself' ? (0, Lang_js_1.__)('Myself') : (0, Lang_js_1.__)('Someone Else');
        orderItemLabel = "".concat((0, Lang_js_1.__)('TWI Gift Subscription'), " \u2014 ").concat(monthsLabel, " / ").concat(recipientLabel);
    }
    var backUrl = lang === 'es' ? '/app/subscriptions/manage?lang=es' : '/app/subscriptions/manage';
    // ---------------------------------------------------------------------------
    // Status pills data
    // ---------------------------------------------------------------------------
    var statusPills = [
        { label: (0, Lang_js_1.__)('Initiate'), active: isInitiate },
        { label: (0, Lang_js_1.__)('Minister'), active: isMinister },
        { label: (0, Lang_js_1.__)('Discourse Subscriber'), active: isDiscourse },
        { label: (0, Lang_js_1.__)('SAT Subscriber'), active: isSat },
    ];
    // ---------------------------------------------------------------------------
    // Invalid product state
    // ---------------------------------------------------------------------------
    if (!product) {
        return (react_1.default.createElement(Box_1.default, { sx: { p: '16px', maxWidth: '1200px', mx: 'auto', backgroundColor: '#f5f6f8' } },
            react_1.default.createElement(Button_1.default, { component: "a", href: backUrl, sx: {
                    display: 'inline-block',
                    mb: '8px',
                    color: '#1c1c3c',
                    fontSize: '14px',
                    textDecoration: 'none',
                    fontWeight: 600,
                    textTransform: 'none',
                    p: 0,
                    '&:hover': { textDecoration: 'underline', backgroundColor: 'transparent' },
                }, disableRipple: true },
                "\u2190 ",
                (0, Lang_js_1.__)('Back to Subscriptions')),
            react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    p: '24px',
                    color: '#d32f2f',
                    fontWeight: 600,
                } },
                react_1.default.createElement(Typography_1.default, { sx: { color: '#d32f2f', fontWeight: 600 } }, (0, Lang_js_1.__)('No product selected. Please return to the subscriptions page.')))));
    }
    // ---------------------------------------------------------------------------
    // Year selector section (discourse only)
    // ---------------------------------------------------------------------------
    var numberedYears = yearOptions.filter(function (opt) { return opt.value !== 'all'; });
    var allYearsOpt = yearOptions.find(function (opt) { return opt.value === 'all'; });
    // ---------------------------------------------------------------------------
    // Main render
    // ---------------------------------------------------------------------------
    return (react_1.default.createElement(Box_1.default, { sx: { p: '16px', maxWidth: '1200px', mx: 'auto', backgroundColor: '#f5f6f8' } },
        react_1.default.createElement(Button_1.default, { component: "a", href: backUrl, sx: {
                display: 'inline-block',
                mb: '8px',
                color: '#1c1c3c',
                fontSize: '14px',
                textDecoration: 'none',
                fontWeight: 600,
                textTransform: 'none',
                p: 0,
                minWidth: 0,
                '&:hover': { textDecoration: 'underline', backgroundColor: 'transparent' },
            }, disableRipple: true },
            "\u2190 ",
            (0, Lang_js_1.__)('Back to Subscriptions')),
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                backgroundColor: '#fff',
                px: '16px',
                py: '8px',
                borderRadius: '6px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                mb: '12px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '10px',
            } },
            react_1.default.createElement(Chip_1.default, { label: "".concat((0, Lang_js_1.__)('MEMBER ID'), ": ").concat(memberId), sx: {
                    backgroundColor: '#1c1c3c',
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: '13px',
                    letterSpacing: '0.3px',
                    borderRadius: '20px',
                    height: '32px',
                    '& .MuiChip-label': { px: '14px' },
                } }),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' } }, statusPills.map(function (pill) { return (react_1.default.createElement(StatusPill, { key: pill.label, label: pill.label, active: pill.active })); }))),
        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h1", sx: {
                fontSize: '22px',
                fontWeight: 700,
                color: '#1c1c3c',
                mb: '14px',
                mt: 0,
                lineHeight: 1.2,
            } }, pageTitle),
        react_1.default.createElement(Box_1.default, { sx: {
                display: 'flex',
                gap: '14px',
                alignItems: 'stretch',
                flexDirection: 'column',
            } },
            react_1.default.createElement(Box_1.default, { sx: { flex: '1 1 0', minWidth: 0, width: { xs: '100%', sm: 'auto' } } },
                product === 'discourse' && (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                        p: '18px',
                    } },
                    react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h2", sx: { mt: 0, mb: '16px', fontSize: '16px', fontWeight: 700, color: '#1c1c3c', lineHeight: 1.2 } }, (0, Lang_js_1.__)('Configure Your Subscription')),
                    discourseCompleted ? (
                    /* User has completed all 12 years */
                    react_1.default.createElement(Box_1.default, { sx: {
                            p: '16px',
                            backgroundColor: 'rgba(25,148,32,0.06)',
                            border: '1px solid rgba(25,148,32,0.3)',
                            borderRadius: '6px',
                        } },
                        react_1.default.createElement(Typography_1.default, { sx: { color: '#1a6e1e', fontWeight: 600, fontSize: '14px' } }, (0, Lang_js_1.__)('You have completed all 12 years of Discourses. No further renewal is needed.')))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Box_1.default, { sx: { mb: '16px' } },
                            react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Language')),
                            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '12px', flexWrap: 'wrap' } }, languageOptions.map(function (opt) { return (react_1.default.createElement(SelectionCard, { key: opt.code, label: opt.name, selected: cartLang === opt.code, onClick: function () { return changeLang(opt.code); } })); }))),
                        react_1.default.createElement(Box_1.default, { sx: { mb: '16px' } },
                            react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Format')),
                            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '12px', flexWrap: 'wrap' } },
                                react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Book'), selected: format === 'book', disabled: year === 'all' || isDigitalOnlyEdition, onClick: function () { return setFormat('book'); } }),
                                react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Digital'), selected: format === 'digital', disabled: rate === 'replacement', onClick: function () { return setFormat('digital'); } })),
                            year === 'all' && (react_1.default.createElement(Typography_1.default, { sx: { mt: '8px', fontSize: '12px', color: '#888', fontStyle: 'italic' } }, (0, Lang_js_1.__)('All 12 Years is available in Digital format only.'))),
                            rate === 'replacement' && (react_1.default.createElement(Typography_1.default, { sx: { mt: '8px', fontSize: '12px', color: '#888', fontStyle: 'italic' } }, (0, Lang_js_1.__)('Replacement Discourses are available in Book format only.'))),
                            isDigitalOnlyEdition && (react_1.default.createElement(Typography_1.default, { sx: { mt: '8px', fontSize: '12px', color: '#888', fontStyle: 'italic' } }, (0, Lang_js_1.__)('This edition is available in Digital (PDF) format only.')))),
                        react_1.default.createElement(Box_1.default, { sx: { mb: '16px' } },
                            react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Year')),
                            yearOptions.length === 0 ? (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#d32f2f', fontWeight: 600 } }, (0, Lang_js_1.__)('No years available.'))) : (react_1.default.createElement(Box_1.default, { sx: { maxWidth: '560px' } },
                                react_1.default.createElement(Box_1.default, { sx: {
                                        display: 'grid',
                                        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                        gap: '8px',
                                    } }, numberedYears.map(function (opt) { return (react_1.default.createElement(YearOption, { key: opt.value, label: opt.label, selected: year === opt.value, onClick: function () { return setYear(opt.value); } })); })),
                                allYearsOpt && (react_1.default.createElement(Box_1.default, { sx: { mt: '8px' } },
                                    react_1.default.createElement(YearOption, { label: allYearsOpt.label, selected: year === allYearsOpt.value, onClick: function () { return setYear(allYearsOpt.value); } })))))),
                        react_1.default.createElement(Box_1.default, null,
                            react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Rate')),
                            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '12px', flexWrap: 'wrap' } },
                                react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Individual'), selected: rate === 'individual', onClick: function () { return setRate('individual'); } }),
                                showFamily && (react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Family'), selected: rate === 'family', onClick: function () { return setRate('family'); } })),
                                !isDigitalOnlyEdition && (react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Replacement'), selected: rate === 'replacement', onClick: function () { return setRate('replacement'); } }))),
                            react_1.default.createElement(RateOptionDescriptions, { product: "discourse", rate: rate })),
                        format === 'book' && (react_1.default.createElement(Box_1.default, { sx: { mt: '20px' } },
                            react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Shipping Address')),
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '12px', color: '#666', mb: '10px', fontStyle: 'italic' } }, (0, Lang_js_1.__)('We will ship your books to this address. Edit if needed.')),
                            react_1.default.createElement(Box_1.default, { sx: {
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                    gap: '10px',
                                    maxWidth: '560px',
                                } },
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('First Name'), value: shipping.first_name, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { first_name: e.target.value })); }, size: "small", fullWidth: true }),
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('Last Name'), value: shipping.last_name, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { last_name: e.target.value })); }, size: "small", fullWidth: true }),
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('Address'), value: shipping.address_1, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { address_1: e.target.value })); }, size: "small", fullWidth: true, sx: { gridColumn: { sm: '1 / span 2' } } }),
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('Apartment, suite, etc. (optional)'), value: shipping.address_2, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { address_2: e.target.value })); }, size: "small", fullWidth: true, sx: { gridColumn: { sm: '1 / span 2' } } }),
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('City'), value: shipping.city, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { city: e.target.value })); }, size: "small", fullWidth: true }),
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('State/Province'), value: shipping.state, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { state: e.target.value })); }, size: "small", fullWidth: true }),
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('ZIP/Postal Code'), value: shipping.postcode, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { postcode: e.target.value })); }, size: "small", fullWidth: true }),
                                react_1.default.createElement(TextField_1.default, { label: (0, Lang_js_1.__)('Country'), value: shipping.country, onChange: function (e) { return setShipping(__assign(__assign({}, shipping), { country: e.target.value })); }, size: "small", fullWidth: true })))))))),
                product === 'sat' && (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                        p: '18px',
                    } },
                    react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h2", sx: { mt: 0, mb: '12px', fontSize: '16px', fontWeight: 700, color: '#1c1c3c', lineHeight: 1.2 } }, (0, Lang_js_1.__)('Subscription Details')),
                    react_1.default.createElement(Box_1.default, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            p: '16px',
                            mb: '20px',
                            border: '2px solid #1c1c3c',
                            borderRadius: '8px',
                            backgroundColor: 'rgba(28,28,60,0.03)',
                        } },
                        react_1.default.createElement(Box_1.default, { sx: {
                                width: '44px',
                                height: '44px',
                                borderRadius: '50%',
                                backgroundColor: '#1c1c3c',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            } },
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { color: '#fff', fontSize: '20px', lineHeight: 1 } }, "\u2713")),
                        react_1.default.createElement(Box_1.default, null,
                            react_1.default.createElement(Typography_1.default, { sx: { fontWeight: 700, fontSize: '15px', color: '#1c1c3c' } }, (0, Lang_js_1.__)('SAT Yearly Subscription')),
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', mt: '4px' } }, (0, Lang_js_1.__)('One-time annual payment, not a recurring charge.')))),
                    react_1.default.createElement(Box_1.default, { sx: { mb: '16px' } },
                        react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Language')),
                        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '12px', flexWrap: 'wrap' } }, languageOptions.map(function (opt) { return (react_1.default.createElement(SelectionCard, { key: opt.code, label: opt.name, selected: cartLang === opt.code, onClick: function () { return changeLang(opt.code); } })); }))),
                    react_1.default.createElement(Box_1.default, null,
                        react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Rate')),
                        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '12px', flexWrap: 'wrap' } },
                            react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Individual') + ' — $100', selected: rate === 'individual', onClick: function () { return setRate('individual'); } }),
                            showFamily && (react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Family') + ' — $50', selected: rate === 'family', onClick: function () { return setRate('family'); } }))),
                        react_1.default.createElement(RateOptionDescriptions, { product: "sat", rate: rate })))),
                product === 'twi-gift' && (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                        p: '18px',
                    } },
                    react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h2", sx: { mt: 0, mb: '6px', fontSize: '16px', fontWeight: 700, color: '#1c1c3c', lineHeight: 1.2 } }, (0, Lang_js_1.__)('That Which Is Subscription — Extension or Gift')),
                    react_1.default.createElement(Typography_1.default, { sx: { mb: '16px', fontSize: '13px', color: '#666', lineHeight: 1.5 } },
                        (0, Lang_js_1.__)('Give yourself or a loved one extended access to TWI — MSIA\'s video streaming platform.'),
                        ' ',
                        "$",
                        TWI_GIFT_PRICE_PER_MONTH.toFixed(2),
                        " ",
                        (0, Lang_js_1.__)('per month'),
                        "."),
                    react_1.default.createElement(Box_1.default, { sx: { mb: '16px' } },
                        react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Duration')),
                        react_1.default.createElement(Box_1.default, { sx: { display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '8px', maxWidth: '560px' } }, TWI_GIFT_DURATION_OPTIONS.map(function (opt) { return (react_1.default.createElement(YearOption, { key: opt.months, label: "".concat((0, Lang_js_1.__)(opt.label), " \u2014 $").concat(getTwiGiftPrice(opt.months).toFixed(2)), selected: giftMonths === opt.months, onClick: function () { return setGiftMonths(opt.months); } })); }))),
                    react_1.default.createElement(Box_1.default, { sx: { mb: '16px' } },
                        react_1.default.createElement(SectionLabel, null, (0, Lang_js_1.__)('Who is this for?')),
                        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '12px', flexWrap: 'wrap' } },
                            react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Myself'), selected: giftRecipient === 'myself', onClick: function () { return setGiftRecipient('myself'); } }),
                            react_1.default.createElement(SelectionCard, { label: (0, Lang_js_1.__)('Someone else'), selected: giftRecipient === 'someone-else', onClick: function () { return setGiftRecipient('someone-else'); } }))),
                    giftRecipient === 'someone-else' && (react_1.default.createElement(Box_1.default, { sx: {
                            mt: '12px',
                            mb: '16px',
                            p: '14px 16px',
                            backgroundColor: '#fff8e1',
                            border: '1px solid #f0c419',
                            borderRadius: '6px',
                        } },
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#333', lineHeight: 1.6, fontWeight: 700, mb: '6px' } },
                            (0, Lang_js_1.__)('IMPORTANT NOTE'),
                            ":"),
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#333', lineHeight: 1.6, mb: '8px' } }, (0, Lang_js_1.__)('Be sure to include in the recipient details below the recipient\'s contact information, such as: full name, phone number, e-mail address, and whether or not they already have an MSIA online user account.')),
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#c62828', lineHeight: 1.6 } },
                            (0, Lang_js_1.__)('If they don\'t have an MSIA online user account, please let them know they need to create one to get TWI access. It\'s free and only takes a few minutes by going to:'),
                            ' ',
                            react_1.default.createElement(Box_1.default, { component: "a", href: lang === 'es' ? 'https://www.msia.org/es/students/signup' : 'https://www.msia.org/students/signup', target: "_blank", rel: "noopener", sx: { color: '#c62828', fontWeight: 600 } }, lang === 'es' ? 'www.msia.org/es/students/signup' : 'www.msia.org/students/signup')))),
                    react_1.default.createElement(Box_1.default, null,
                        react_1.default.createElement(SectionLabel, null, giftRecipient === 'someone-else'
                            ? (0, Lang_js_1.__)('Recipient Details')
                            : (0, Lang_js_1.__)('Notes (optional)')),
                        react_1.default.createElement(TextField_1.default, { multiline: true, rows: 4, fullWidth: true, value: giftNotes, onChange: function (e) { return setGiftNotes(e.target.value); }, placeholder: giftRecipient === 'someone-else'
                                ? (0, Lang_js_1.__)('Full name, phone, email, whether they have an MSIA account…')
                                : (0, Lang_js_1.__)('Any special instructions for our team…'), inputProps: { maxLength: 500 }, helperText: "".concat(giftNotes.length, "/500") }))))),
            react_1.default.createElement(Box_1.default, { sx: {
                    width: '100%',
                } },
                react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                        p: '18px',
                    } },
                    react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h2", sx: { mt: 0, mb: '14px', fontSize: '16px', fontWeight: 700, color: '#1c1c3c', lineHeight: 1.2 } }, (0, Lang_js_1.__)('Order Summary')),
                    discourseCompleted && product === 'discourse' ? (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#888', fontStyle: 'italic', mb: '16px' } }, (0, Lang_js_1.__)('No items to purchase.'))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Box_1.default, { sx: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                gap: '10px',
                                mb: '10px',
                            } },
                            react_1.default.createElement(Typography_1.default, { sx: { flex: 1, fontSize: '14px', color: '#333', lineHeight: 1.5 } }, orderItemLabel),
                            react_1.default.createElement(Typography_1.default, { sx: { fontWeight: 700, fontSize: '14px', color: '#333', whiteSpace: 'nowrap' } },
                                "$",
                                merchandisePrice)),
                        shippingFee > 0 && (react_1.default.createElement(Box_1.default, { sx: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mb: '8px',
                                fontSize: '14px',
                                color: '#555',
                            } },
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555' } }, isUsCountry(shipping.country)
                                ? (0, Lang_js_1.__)('Shipping (US)')
                                : (0, Lang_js_1.__)('Shipping (International)')),
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555', whiteSpace: 'nowrap' } },
                                "$",
                                shippingFee))),
                        caTax > 0 && (react_1.default.createElement(Box_1.default, { sx: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mb: '8px',
                                fontSize: '14px',
                                color: '#555',
                            } },
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555' } }, (0, Lang_js_1.__)('CA Tax')),
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555', whiteSpace: 'nowrap' } },
                                "$",
                                caTax.toFixed(2)))),
                        react_1.default.createElement(Divider_1.default, { sx: { mb: '10px', borderColor: '#e8e8e8' } }),
                        react_1.default.createElement(Box_1.default, { sx: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mb: '14px',
                            } },
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '15px', fontWeight: 700, color: '#1c1c3c' } }, (0, Lang_js_1.__)('Total')),
                            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '18px', fontWeight: 700, color: '#1c1c3c' } },
                                "$",
                                orderPrice.toFixed(2))),
                        !showPayment ? (react_1.default.createElement(react_1.default.Fragment, null,
                            (function () {
                                var giftMissingRecipient = product === 'twi-gift'
                                    && giftRecipient === 'someone-else'
                                    && giftNotes.trim() === '';
                                return (react_1.default.createElement(Button_1.default, { fullWidth: true, disabled: paymentLoading || giftMissingRecipient, onClick: handlePayNow, sx: {
                                        backgroundColor: '#1c1c3c',
                                        color: '#fff',
                                        borderRadius: '6px',
                                        height: '46px',
                                        fontSize: '14px',
                                        fontWeight: 700,
                                        letterSpacing: '0.5px',
                                        textTransform: 'none',
                                        '&:hover': {
                                            backgroundColor: '#2a2a4c',
                                        },
                                        '&:disabled': {
                                            backgroundColor: '#999',
                                            color: '#fff',
                                        },
                                    } }, paymentLoading ? react_1.default.createElement(CircularProgress_1.default, { size: 22, sx: { color: '#fff' } }) : (0, Lang_js_1.__)('Pay Now')));
                            })(),
                            product === 'twi-gift'
                                && giftRecipient === 'someone-else'
                                && giftNotes.trim() === '' && (react_1.default.createElement(Typography_1.default, { sx: { mt: '8px', fontSize: '12px', color: '#c62828', fontStyle: 'italic' } }, (0, Lang_js_1.__)('Please add the recipient\'s details to continue.'))),
                            paymentError && (react_1.default.createElement(Alert_1.default, { severity: "error", sx: { mt: '12px' } }, paymentError)))) : clientSecret ? (react_1.default.createElement(Box_1.default, { sx: { mt: '12px' } },
                            react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                                react_1.default.createElement(react_stripe_js_1.Elements, { stripe: stripePromise, options: { clientSecret: clientSecret, locale: lang } },
                                    savedMethods.length > 0 && (react_1.default.createElement(SavedPaymentMethods_1.default, { payment_methods: savedMethods })),
                                    react_1.default.createElement(CheckoutForm_1.default, { clientSecret: clientSecret, customerId: customerId || '', stripePromise: stripePromise, loggedIn: true, origin: "subscription-cart" }))))) : null)))))));
};
// ---------------------------------------------------------------------------
// Mount
// ---------------------------------------------------------------------------
var subscriptionCartEl = document.getElementById('subscription-cart');
if (subscriptionCartEl) {
    (0, mountIsland_1.mountIsland)(subscriptionCartEl, react_1.default.createElement(SubscriptionCart, null));
}
exports.default = SubscriptionCart;
